const translations = {
  'sevillie.seo.title': 'Living & Teaching English in Seville - Cost of Living in 2023',
  'sevillie.seo.description':
    'Thinking of living and teaching English in Seville? Take a look at the inside information from TEFL Iberia, including cost of living, cultural tips and more.',
  'sevillie.sec1.title': 'Life in Seville',
  'sevillie.sec2.title': 'Living & Teaching English in Seville',
  'sevillie.sec2.description': `A seductive city that’s easy to fall head-over-heels in love with, Seville or
      Sevilla to
       Spanish speakers mixes big city energy with small town charm. Andaluscía’s sun-soaked capital
      is an intoxicating blend of vibrant plazas, sublime architecture, centuries-old
      traditions and captivating culture.`,
  'sevillie.sec2.text1': `Home to around 700,000 Sevillanos, including a significant expat
    population, Seville is relatively small – making it easy to get around. Yet,
    despite its compact size, it makes a big impact on the people who live
    here.`,
  'sevillie.sec2.text2': `From old-world tapas joints and intimate flamenco clubs to sprawling parks and breathtaking monuments, there’s so much to see and do in this magnificent city. And, while Barcelona and Madrid get most of the fanfare, many Spanish people argue that Seville is the quintessential Spanish city.`,

  'sevillie.sec3.titleL': 'Teaching English in Seville',
  'sevillie.sec3.titleR': 'The TEFL Jobs Market',
  'sevillie.sec3.textL1': `TWhile tourists get swept up in the romance of a whirlwind visit, to really get
    beneath the surface of Seville you have to live here. And one of the easiest
    ways to live and work in Seville is to teach English`,
  'sevillie.sec3.textL2': ` While it’s not quite as cosmopolitan as Barcelona or Madrid, the standard of
    English in Seville has improved immensely in recent years. Sevillanos pride
    themselves on the development of their English-speaking abilities and, as
    such, there’s an increasing demand for English teachers in the city.`,
  'sevillie.sec3.textR1': `The Spanish economy is now one of the fastest growing large economies in
    Europe. What’s more, the ability to speak English is regarded as a key skill
    by large and small businesses, meaning there’s a rising demand for English
    teachers in Spain. Meanwhile, in Seville, the city’s student population is
    increasingly aware of the importance of learning English, as many of them look
    to travel abroad for new opportunities.`,
  'sevillie.sec3.textR2': `So, it stands to reason that the <accentedLink> TEFL </accentedLink> jobs market in Spain continues to go from strength to strength, with English
  teaching jobs in Seville available at private language academies,
  international schools, business schools and public schools, not to mention an
  abundance of private tuition opportunities.`,

  'sevillie.sec3.title': 'The Cost Of Living',
  'sevillie.sec3.description':
    'Seville is an extremely affordable place to live. For a city with so much culture, history and beauty, the cost of living in the Andaluscían capital is very low, particularly when compared to large cities in Spain such as Barcelona and Madrid, as well as major cities throughout the rest of the world.',
  'sevillie.sec3.fact':
    'Here’s a cost of living comparison with a few big cities that our students regularly come from.',

  'sevillie.sec3.item': 'Item',
  'sevillie.sec3.sevillie': 'Sevillie',
  'sevillie.sec3.london': 'London',
  'sevillie.sec3.newYork': 'New York',
  'sevillie.sec3.austin': 'Austin',
  'sevillie.sec3.bedroomApartment': '1 bedroom in city-centre shared apartment',
  'sevillie.sec3.mealInExpensive': 'Meal at inexpensive restaurant',
  'sevillie.sec3.cappuccino': 'Cappuccino',
  'sevillie.sec3.beer': 'Large local beer in bar',
  'sevillie.sec3.metroTicket': '1-way metro ticket',
  'sevillie.sec3.kmInTaxi': '1 km in a taxi',
  'sevillie.sec3.source': 'Source',

  'sevillie.sec4.title': 'Making The Most Of Living In Seville',
  'sevillie.sec4.text1': ` Delivering quality TEFL courses is our business, but we are also here to guide
 your entire experience while living in Seville. We’ve got your back from the
 very first step, with expert assistance when it comes to getting your
    student visa
  and we’ll also help you
    open your Spanish bank account
  . Our in-house accommodation service will help you get settled in the city, while our dedicated careers service will help you secure work post graduation. `,
  'sevillie.sec4.text2':
    'With secure foundations laid and the admin side of things in place, you’ll be ready to immerse yourself in all that Seville has to offer. And there really is so much to discover. Magnificent Moorish architecture, imperious palaces, picturesque plazas, electrifying street festivals, romantic cobbled streets, secret flamenco bars… you name it, this city has got it!',
  'sevillie.sec4.text3':
    'With that in mind, here’s just a snapshot of what you can expect from life in Seville…',

  'sevillie.sec5.title': 'Top Six Things to Do in Seville',
  'sevillie.sec5.imgDescription':
    'This photo is from Gardens of the Real Alcázar Palace in Seville.',

  'sevillie.sec5.thing1.title': 'Let Flamenco Cast Its Spell',
  'sevillie.sec5.thing1.text':
    'The folklore of flamenco is deeply embedded in the city. The ancient art form was developed in Seville’s Gitano subculture and duende – the Spanish term for a heightened state of emotion and expression – is part of the fabric of the city. ',
  'sevillie.sec5.thing1.text2': `
  You’ll be blown away by the incredible shows at tablaos such as
                    <accentedLink>
                      Casa de la Memoria
                    </accentedLink>
                    and
                    <accentedLink2>
                      La Casa del Flamenco
                    </accentedLink2>
                    . But live in the city long enough, and you’ll get to experience flamenco at its
                    most authentic – a spontaneous small hours performance in an intimate flamenco
                    bar, capturing the true essence of duende.
  `,
  'sevillie.sec5.thing1.link1': 'The 12 Best Places to Watch Flamenco',

  'sevillie.sec5.thing2.title': 'Be a culture vulture',
  'sevillie.sec5.thing2.text':
    'There’s an abundance of cultural delights throughout Seville. The jewel in the city’s crown is undoubtedly the spellbinding palatial complex Royal Alcázar, which has served as a setting for Game of Thrones. Don’t forget to take advantage of the free admission on Mondays.',
  'sevillie.sec5.thing2.text2':
    'And don’t miss one of Spain’s most impressive art museums, the Museo de Bellas Artes, which houses works by the likes of Velázquez and Murillo, and stages a fantastic pop-up local art market every Sunday.',
  'sevillie.sec5.thing2.link1': 'The 8 Best Museums in Seville',

  'sevillie.sec5.thing3.title': 'Enjoy an evening tapeo',
  'sevillie.sec5.thing3.text':
    'Central to a summer in Seville is the tapeo – an evening tour of tapas bars, all bustling with locals sharing stories and small plates of delicious local delicacies.',
  'sevillie.sec5.thing3.text2':
    'A big part of the social scene in Seville, evening meals take place after the searing heat of the summer sun has subsided – most locals don’t even think about venturing out before 9pm. Chances are, your most memorable meals while living in Seville will be tapas and tinto veranos shared between friends on warm summer nights.',
  'sevillie.sec5.thing3.link1': '10 Best Tapas Bars in Seville',

  'sevillie.sec5.thing4.title': 'While away the hours in a city park',
  'sevillie.sec5.thing4.text': `Seville is home to several impressive parks, each offering the chance to escape
  the hustle and bustle of the city and enjoy some expansive green space. Parque
  María Luisa is the most famous and is home to the semi-circular splendour of
   <accentedLink>
   Plaza España
  </accentedLink> – all extravagant arches and magnificent murals. To the north, Parque Miraflores
  is a secret oasis and the largest green space in the city, while Parque del
  Alamillo is a huge park with abundant native plants and wildlife, as well as
  train rides and water skiing. is a must for any sports fan and, with countless
  5-a-side football pitches throughout the city, there are plenty of opportunities
  for football fanatics to get their fix. Add running tracks, basketball and padel
  courts, gyms, swimming pools and rock climbing centres into the mix and you’ve
  got a city that’s perfect for sports lovers.`,
  'sevillie.sec5.thing4.link1': 'Sevilla through its parks',

  'sevillie.sec5.thing5.title': 'Stir the senses during La Semana Santa and La Feria de Abril',
  'sevillie.sec5.thing5.text': `For pure pageantry, drama, emotion and sheer spectacle, Semana Santa (holy week) in Seville takes some beating. With over 60 processions over the Easter week, it’s Seville’s largest celebration. For newcomers, it's an essential experience.`,
  'sevillie.sec5.thing5.text2': `In the last week of April, locals let loose at La Feria de Abril – a kaleidoscope of colour, music, dancing and all round good times. Lines of large tents, or casetas, host week-long private parties (get to know a local and you’re in), while city-wide street parades and activities take the merriment to another level.`,
  'sevillie.sec5.thing5.link1': 'Events, holidays & festivals in Seville',

  'sevillie.sec5.thing6.title': 'Get thrifty and nab a bargain',
  'sevillie.sec5.thing6.text': ` Seville is a veritable treasure trove for bargain hunters, with several superb second-hand markets running throughout the city. The best of the bunch is the Mercado del Jueves (Thursday market). Popping up every Thursday in Calle Feria, it’s the city’s oldest market – you’ll find vintage street clothes, flamenco dresses, books, antiques and all manner of trinkets, curios and one-of-a-kind wonders.`,
  'sevillie.sec5.thing6.link1': 'Flea and Street Markets in Seville',

  'sevillie.sec5.moreInfo': `For more about living and teaching English in Seville,
  <strong>
    take a look at one of our
  </strong>
  <accentedLink>
  recent blog posts.
</accentedLink>`,
};

export default translations;
